import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Battery2BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_2_bar"}/>
}
